import { ConvertDetails, TaskDetails } from 'components/page/index';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { setModuleReadonlyMode } from 'components/page/DetailsSubpanels/flow/actions';
import { Actions } from '../components/index';

const {
  PhantomId,
  ObjectTypes,
  ThemeTypes,
  DetailModules,
} = Enums;
const { TaskOpen } = DetailModules;
const { Leads } = ObjectTypes;

class Conversion extends React.Component {
  componentDidMount() {
    const { setModuleReadonlyMode } = this.props;
    setModuleReadonlyMode(TaskOpen);
  }
  render() {
    const { objectId } = this.props;
    return (
      <Fragment>
        <ConvertDetails objectId={objectId} />
        <TaskDetails
          taskId={PhantomId}
          objectId={objectId}
          objectType={Leads}
          theme={ThemeTypes.Leads}
          convertDefaultValue
          disableActions
        />
        <Actions objectId={objectId} />
      </Fragment>
    );
  }
}

const mapStateToProps = null;
const mapDispatchToProps = {
  setModuleReadonlyMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversion);



// WEBPACK FOOTER //
// ./src/views/Conversion/container/index.jsx